import React from 'react';
import athenaLogoBlue from '../assets/athena-logo-blue.png';
import npsfLogo from '../assets/npsf-logo.png';
import '../styles/HomePage.css';

const CTAFooter: React.FC = () => {
  return (
    <div className='cta-footer'>
      <div className='cta-footer-top'>
        <img
          src={athenaLogoBlue}
          alt='Athena logo'
          className='cta-footer-logo'
        />
        <nav className='cta-footer-nav'>
          <ul>
            <li>
              <a href='#' className='cta-footer-link'>
                Register
              </a>
            </li>
            <li>
              <a
                href='/assets/Athena4P_FAQ_25SEP2023.pdf'
                className='cta-footer-link'
                target='_blank'
                rel='noopener noreferrer'
              >
                FAQ
              </a>
            </li>
            <li>
              <a
                href='mailto:athena@npsfoundation.org'
                className='cta-footer-link'
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className='cta-footer-bottom'>
        <hr className='cta-footer-line' />
        <div className='powered-by-content'>
          <span>Powered By</span>
          <img src={npsfLogo} alt='Naval Postgraduate School Foundation logo' />
        </div>
      </div>
    </div>
  );
};

export default CTAFooter;
